import React, { useCallback } from 'react';

import SearchMapMarker from '@/components/route/search/SearchMapMarker';
import { TCurrency } from '@/config/locales';
import { IMapMarkerData } from '@/redux/selectors/search/map';
import { IGeocodeFeature } from '@/services/types/mapbox/mapboxApi';

import SearchMapAddressMarker from '../SearchMapAddressMarker';
import EscapeMapMarker from '../SearchMapMarker/EscapeMapMarker';

const MAP_ADDRESS_MARKER_ID = 999999;

interface IProps {
  container: Element | null;
  currency: TCurrency;
  markers: IMapMarkerData[];
  openedMarker?: number | null;
  onMarkerClick?: (id: number | null) => void;
  promoSlug?: string;
  isOnWishlist?: boolean;
  addressLat?: number;
  addressLng?: number;
  place?: IGeocodeFeature | null;
  isRetrieved?: boolean;
}

const SearchMapMarkers: React.FC<IProps> = ({
  container,
  currency,
  markers,
  openedMarker,
  onMarkerClick,
  promoSlug,
  isOnWishlist,
  addressLat,
  addressLng,
  place,
  isRetrieved,
}) => {
  const handleOnClick = useCallback(
    (id: number) => onMarkerClick?.(id === openedMarker ? null : id),
    [openedMarker, onMarkerClick],
  );

  return (
    <>
      {markers.map(marker => {
        if (marker.rentals.length > 0) {
          const id = marker.rentals[0]?.id;

          return (
            <SearchMapMarker
              key={id}
              isPopupVisible={id === openedMarker}
              container={container}
              currency={currency}
              onClick={handleOnClick}
              promoSlug={promoSlug}
              isOnWishlist={isOnWishlist}
              {...marker}
            />
          );
        }
      })}
      {markers.map(marker => {
        if (marker.escapes?.length) {
          const id = marker.escapes[0]?.id;

          return (
            <EscapeMapMarker
              key={id}
              isPopupVisible={id === openedMarker}
              container={container}
              currency={currency}
              onClick={handleOnClick}
              promoSlug={promoSlug}
              isOnWishlist={isOnWishlist}
              {...marker}
            />
          );
        }
      })}
      <SearchMapAddressMarker
        id={MAP_ADDRESS_MARKER_ID}
        lat={addressLat}
        lon={addressLng}
        container={container}
        onClick={handleOnClick}
        isPopupVisible={openedMarker == MAP_ADDRESS_MARKER_ID}
        place={place}
        isRetrieved={isRetrieved}
      />
    </>
  );
};

export default SearchMapMarkers;
